import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";

export const RoundSelect = ({ rounds, value, onChange }) => (
  <div className="w-full sm:w-80">
    <Select value={value || undefined} onValueChange={onChange}>
      <SelectTrigger data-testid="round-select" className="h-11 bg-[#121824] border-[#26334D]">
        <SelectValue placeholder="Scegli la giornata" />
      </SelectTrigger>
      <SelectContent className="bg-[#121824] border-[#26334D] max-h-80">
        {rounds.map((r) => (
          <SelectItem key={r.key} value={r.key} data-testid={`round-option-${r.key}`}>
            {r.label} · {{ open: "aperta", live: "in corso", suspended: "sospesa", scored: "conclusa" }[r.status]}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  </div>
);
